<template>
	<k-dialog v-model="dialog_open" max-width="600" persistent scrollable>
		<k-card>
			<k-card-title style="border-bottom:1px solid #999"><b v-html="resource.description"></b></k-card-title>

			<k-card-text class="mt-3" style="font-size:16px">
				<div v-if="blueprint_link||student_booklet_link||paper_link">
					<div class="mb-3 text-center">{{assessment_type_label}} Assessment Resources:</div>

					<div class="mb-3 d-flex justify-center flex-wrap">
						<k-btn v-if="blueprint_link" :href="blueprint_link.url" target='_blank' color="pink accent-4" class="ma-1 k-tight-btn" small dark>
							<k-icon small class="mr-2">fas fa-map</k-icon>Assessment Blueprint
						</k-btn>

						<k-btn v-if="student_booklet_link" :href="student_booklet_link.url" target='_blank' color="pink accent-4" class="ma-1 k-tight-btn" small dark>
							<k-icon small class="mr-2">fas fa-file-alt</k-icon>Student Test Booklet
						</k-btn>

						<k-btn v-if="paper_link" :href="paper_link.url" target='_blank' color="pink accent-4" class="ma-1 k-tight-btn" small dark>
							<k-icon small class="mr-2">fas fa-file-alt</k-icon>{{paper_link_label}}
						</k-btn>
					</div>
				</div>

				<div v-if="resource.long_description" v-html="resource.long_description" class="mb-5"></div>

				<div v-if="assessment_engine_link" class="text-center mt-3">
					<k-btn v-if="assessment_engine_link=='lti'" @click="open_lti_link" color="pink accent-4" class="k-tight-btn" dark>
						<k-icon small class="mr-2">fas fa-clipboard-list</k-icon>Open Assessment in {{assessment_type_label}}
					</k-btn>
					<k-btn v-else :href="assessment_engine_link" target='_blank' color="pink accent-4" class="k-tight-btn" dark>
						<k-icon small class="mr-2">fas fa-clipboard-list</k-icon>Open Assessment in {{assessment_type_label}}
					</k-btn>
				</div>
				<!-- add button to add to google classroom if we're using the addon and aren't in the chooser -->
				<div v-if="site_config.use_google_classroom_addon=='yes' && !lti_chooser" class="text-center mt-3">
					<k-btn @click="$emit('add_to_gc')" color="secondary" class="k-tight-btn" dark>
						<img src="./../../images/google_classroom_logo.png" style="height:18px;border-radius:2px;margin-right:8px;margin-top:0px">Add to Google Classroom
					</k-btn>
				</div>
				<!-- add button to choose if we're in the chooser -->
				<div v-if="lti_chooser" class="text-center mt-3">
					<k-btn dark color="indigo darken-2" @click="$emit('lti_chooser_choose')">Choose Assessment <k-icon class="ml-2">fas fa-circle-check</k-icon></k-btn>
				</div>
			</k-card-text>

			<k-card-actions class="pa-3" style="border-top:1px solid #999">
				<k-btn v-if="assessment_toolkit_url" small color="secondary" target="_blank" :href="assessment_toolkit_url"><k-icon small class="mr-2">fas fa-tools</k-icon>{{assessment_toolkit_label}}</k-btn>

				<k-spacer/>
				
				<k-btn color="primary" @click="$emit('dialog_cancel')">Done <k-icon small class="ml-2">fas fa-check</k-icon></k-btn>
			</k-card-actions>
		</k-card>
	</k-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	props: {
		resource: { type: Object, required: true },
		// nreq: { type: String, required: false, default() { return ''} },
	},
	data() { return {
		dialog_open: true,
	}},
	computed: {
		...mapState(['user_info', 'site_config']),
		...mapGetters(['lti_chooser']),

		assessment_toolkit_label() {
			// TODO: make this more configurable...
			if (this.site_config.app_name == 'Skyline') {
				return 'Assessment Overview'
			} else {
				return 'Assessment Toolkit'
			}
		},

		assessment_toolkit_url() {
			// TODO: make this more configurable...
			if (this.site_config.app_name == 'Skyline') {
				// for skyline we're currently using the 'blueprint' link from the resource
				let o = this.resource.supp_links.find(x => x.type == 'blueprint') 
				if (o) return o.url
				else return ''
			}
			
			// henry
			return 'https://sites.google.com/henry.k12.ga.us/performance/home'	// ?authuser=0
		},
		
		assessment_type_label() {
			// TODO: make this more configurable...
			if (this.site_config.app_name == 'Skyline') {
				return 'CheckPoint'
			}

			return this.resource.assessment_type == 'writable' ? 'Writable' : 'Renaissance'
		},
		
		paper_link_label() {
			return this.resource.assessment_type == 'writable' ? 'Writable Extended Response TE Booklet' : 'Teacher Test Booklet'
		},

		paper_link() { return this.resource.supp_links.find(x => x.type == 'paper') },

		blueprint_link() { 
			// TODO: make this more configurable...
			if (this.site_config.app_name == 'Skyline')  return ''
			return this.resource.supp_links.find(x => x.type == 'blueprint') 
		},

		student_booklet_link() { return this.resource.supp_links.find(x => x.type == 'student_booklet') },

		assessment_engine_link() {
			// TODO: make this more configurable...
			if (this.site_config.app_name == 'Skyline') {
				return 'lti'

			} else if (this.resource.assessment_type == 'writable') {
				// ...
				return this.resource.url
				// return `https://henry.illuminateed.com/live/?assessment_id=${this.resource.url}&page=Assessment_DetailsController&overview_redirect=1`
			} else {
				// for illuminate assessments the url contains the assessment_id; use this format to link to the assessment:
				return `https://henry.illuminateed.com/live/?assessment_id=${this.resource.url}&page=Assessment_DetailsController&overview_redirect=1`
			}
		},
	},
	methods: {
		open_lti_link() {
			this.$emit('open_lti_assessment')
			this.$emit('dialog_cancel')
		},
	},
}
</script>

<style lang="scss">
</style>
